import ExternalFile from "./ExternalFile";

export { ExternalFile };
